import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Divider, Modal } from "antd";
import { observer } from "mobx-react";
import { useEffect, useRef, useState } from "react";
import { createCookiePolicyTable } from "@devowl-wp/react-cookie-banner";
import { __ } from "../../../../utils/i18n.js";
const ConsentTableRecordCookiePolicy = observer(({ record })=>{
    const [isOpen, setIsOpen] = useState(false);
    const { cookiePolicy } = record.revision.data;
    const ref = useRef();
    // Deactivate TOC links in preview
    useEffect(()=>{
        if (isOpen && ref.current) {
            ref.current.querySelectorAll(".devowl-wp-react-cookie-banner-cookie-policy").forEach(createCookiePolicyTable);
            ref.current.querySelectorAll(`a[href^="#"]`).forEach((link)=>{
                link.style.cursor = "not-allowed";
                link.addEventListener("click", (e)=>e.preventDefault());
            });
        }
    }, [
        isOpen
    ]);
    return cookiePolicy ? /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Divider, {
                children: __("Cookie policy as at the time of consent")
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "description",
                children: __("Use the button below to see what the content of the cookie policy looked like at the time of the user's consent. Styles, e.g. from your theme, which may have influenced the cookie policy page, are not taken into account.")
            }),
            /*#__PURE__*/ _jsx(Modal, {
                title: __("Cookie policy as at the time of consent"),
                open: isOpen,
                onCancel: ()=>setIsOpen(false),
                cancelText: __("Close"),
                okButtonProps: {
                    style: {
                        display: "none"
                    }
                },
                width: "calc(100% - 50px)",
                destroyOnClose: true,
                children: /*#__PURE__*/ _jsx("div", {
                    ref: ref,
                    style: {
                        marginTop: 35
                    },
                    dangerouslySetInnerHTML: {
                        __html: cookiePolicy
                    }
                })
            }),
            /*#__PURE__*/ _jsx("button", {
                className: "button button-large",
                onClick: ()=>setIsOpen(true),
                children: __("Open cookie policy content")
            })
        ]
    }) : null;
});
export { ConsentTableRecordCookiePolicy };
